export enum MediaType {
  USER_MEDIA = 'UserMedia',
  DISPLAY_MEDIA = 'DisplayMedia',
}

export const mediaTypeMap = new Map([
  ['Share', MediaType.DISPLAY_MEDIA],
  ['USB', MediaType.USER_MEDIA],
]);

// export const VIDEO_DIMENSIONS = {
//   width: 1920,
//   height: 1080,
//   aspectRatio: 16 / 9,
// } as const;
export const VIDEO_DIMENSIONS = {
  width: 1920,
  height: 1080,
  aspectRatio: 16 / 9,
} as const;

export const DISPLAY_DIMENSIONS = {
  width: VIDEO_DIMENSIONS.width,
  height: Math.round(VIDEO_DIMENSIONS.width / VIDEO_DIMENSIONS.aspectRatio), // Calculate dynamically
};

export const CROP_REGION = {
  x: 300,
  y: 100,
  width: 800,
  height: 600,
} as const;

export const INITIAL_GLOBAL_STATE = {
  deviceId: '',
  inputDevices: [],
  framesCount: 0,
  isStart: false,
  isVideoFrozen: false,
  isExamEnded: false,
  optionValueDevice: 'USB',
  doctorName: '',
  openGR: false,
  openPanel: true,
  selectedItem: 'Select your machine',
  approach: 'newWS' as 'newWebRTC' | 'oldWebRTC' | 'newWS', // Explicit typing
  pixelSpacingConfig: {},
  selectedItemsMultidrop: [],
  viewList: [],
  receivedData: null,
  configMachine: {},
  planes: {
  },
  pixelSpacingMap: {} as Record<string, {
    estimated_mm_per_pixel: number | null;
    spacing_px_mode: number | null;
    det_conf: number;
    roi_xyxy: number[];
    dashes_selected: number;
    dashes_after_alignment: number;
    mode_count: number;
    best_area_key: string | null;
    ok: boolean;
    status: string;
    message: string;
    datetime: string;
  }>,
  ratingScore: 0,
  lastDetectedPlane: '',
  patient: null as any | null,
  pregnancy: null as any | null,
  showPatientPregnancyModal: false,
};
